<template>
  <img
    src="@/assets/img/svg/maintenance-icon.svg"
    alt="Maintenance"
    width="60"
    height="60"
  />
</template>
